import React from 'react';
import type {usePhotoTagSuggestions} from '../../services/photos/usePhotoTagSuggestions';

export default function PhotoTagFilter({suggestions,selected,onChange}:{suggestions:ReturnType<typeof usePhotoTagSuggestions>;selected:string[];onChange:(ids:string[])=>void}){
 return <fieldset className="photo-tag-filter min-w-0 sm:col-span-2">
  <legend className="text-sm mb-1">Tags</legend>
  <div className="grid sm:grid-cols-2 gap-2">
   <input aria-label="Find tag filters" maxLength={80} placeholder="Find a tag…" value={suggestions.search} onChange={e=>suggestions.setSearch(e.target.value)} className="photo-filter-field"/>
   <select aria-label="Add tag filter" value="" disabled={suggestions.loading||!!suggestions.error||selected.length>=100} onChange={e=>{if(e.target.value)onChange([...selected,e.target.value]);}} className="photo-filter-field">
    <option value="">{suggestions.loading?'Loading tags…':'Choose a tag…'}</option>
    {suggestions.data?.suggestions.filter(tag=>!selected.includes(tag.id)).map(tag=><option key={tag.id} value={tag.id}>{tag.label}</option>)}
   </select>
  </div>
  {suggestions.error&&<p role="alert" className="text-sm text-red-700">{suggestions.error} <button type="button" className="min-h-11 underline" onClick={suggestions.retry}>Retry tags</button></p>}
 </fieldset>;
}
